"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowLocalStorageRepository = void 0;
const Repository_1 = require("./Repository");
class WindowLocalStorageRepository extends Repository_1.Repository {
    set(value) {
        return Promise.resolve(window.localStorage.setItem(this.key, JSON.stringify(value)));
    }
    get() {
        const item = window.localStorage.getItem(this.key);
        return Promise.resolve(item ? JSON.parse(item) : undefined);
    }
    clear() {
        return Promise.resolve(window.localStorage.removeItem(this.key));
    }
}
exports.WindowLocalStorageRepository = WindowLocalStorageRepository;
